import { useState, useEffect } from "react";
 /* eslint-disable no-unused-vars */
import React from 'react'
 import Skeletonui from '../Components/Skeletonui'
import Navbarsection from "../views/Home/Navbarsection";
import Footersection from "../views/Home/Footersection";
 import Iframe from 'react-iframe'

function Accounts() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <>

    
    <Navbarsection />
    
          <div className=""> 
          {loading ? <Skeletonui />  :  <Iframe url="https://www.m.sitekitpro.com/my-account/"
             width="100%"
             height="700px" 
             display="block"
             position="relative" scrolling="no" overflow-y="hidden" />   }
    
            {/*  Dextop Only  */}
             
           </div>
    
        
    <Footersection />
     
      
    
    </>
  );
}

export default Accounts;
  